import type { HoursContent, Branding } from '../../../lib/site-schema';

interface Props {
  content: HoursContent;
  branding: Branding | null;
  compact?: boolean;
}

export default function HoursSection({ content, branding, compact }: Props) {
  const primary = branding?.primaryColor || '#d97706';

  return (
    <div className={compact ? 'px-4 py-5' : 'px-6 py-10'}>
      {content.heading && (
        <div className="text-center mb-5">
          <h2
            className={`${compact ? 'text-sm' : 'text-xl'} font-bold`}
            style={{ color: '#292524', fontFamily: branding?.fontHeading, letterSpacing: '-0.01em' }}
          >
            {content.heading}
          </h2>
          <div className="w-10 h-0.5 mx-auto mt-2 rounded-full" style={{ background: primary }} />
        </div>
      )}
      <div
        className={`max-w-sm mx-auto rounded-xl overflow-hidden`}
        style={{ background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}
      >
        {(content.hours || []).map((h, i) => (
          <div
            key={i}
            className={`flex items-center justify-between ${compact ? 'px-3 py-1.5' : 'px-4 py-2.5'}`}
            style={{
              background: i % 2 === 0 ? '#fafaf9' : '#fff',
              borderBottom: i < (content.hours || []).length - 1 ? '1px solid #f5f5f4' : 'none',
            }}
          >
            <div className="flex items-center gap-2">
              <span
                className={`${compact ? 'text-[10px]' : 'text-xs'} font-semibold`}
                style={{ color: '#44403c' }}
              >
                {h.day}
              </span>
            </div>
            <span
              className={`${compact ? 'text-[10px]' : 'text-xs'} font-medium tabular-nums`}
              style={{ color: h.closed ? '#d6d3d1' : primary }}
            >
              {h.closed ? 'Closed' : `${h.open} – ${h.close}`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
